import React, {useEffect, useMemo, useState} from 'react';
import {Text, View} from 'react-native';
import {globalFontStyle} from '../assets';
import Colors from '../assets/Color/Colors';
import {globalConfigurableData, GlobalScreens} from '../utils/globalConstant';

const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

export const TimerApp = ({
  deadline = new Date().toString(),
  timerExpireCallback = () => {},
  customStyle,
  isMarketMaking,
}) => {
  const parsedDeadline = useMemo(() => Date.parse(deadline), [deadline]);
  const [time, setTime] = useState(parsedDeadline - Date.now());
  const valueObject = isMarketMaking
    ? {
        d: time / DAY,
        h: (time / HOUR) % 24,
        m: (time / MINUTE) % 60,
        s: (time / SECOND) % 60,
      }
    : {
        h: (time / HOUR) % 24,
        m: (time / MINUTE) % 60,
        s: (time / SECOND) % 60,
      };

  useEffect(() => {
    const interval = setInterval(() => {
      if (parsedDeadline - Date.now() >= 0) {
        setTime(parsedDeadline - Date.now());
      } else {
        timerExpireCallback();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [parsedDeadline]);

  const getDisplayVal = (value, label) => {
    try {
      const data =
        Math.floor(value).toString().padStart(2, '0') +
        (label !== 's' ? ': ' : '');
      const dataMM =
        Math.floor(value).toString().padStart(2, '0') +
        label +
        (label !== 's' ? ': ' : '');
      return isMarketMaking ? dataMM : data;
    } catch (e) {}
  };

  return (
    <>
      <View style={{flexDirection: 'row'}}>
        {Object.entries(valueObject).map(([label, value]) => (
          <View key={label}>
            <Text
              style={[
                {
                  ...globalFontStyle.appFontSubText,
                  color: GlobalScreens.Event.InvestedTxt,
                },
                customStyle,
              ]}>
              {value < 0
                ? getDisplayVal(0, label)
                : getDisplayVal(value, label)}
            </Text>
          </View>
        ))}
      </View>
    </>
  );
};
